import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {CyClass} from '../../../common/cy-classes';
import { IBlueRibbonPartyJackpot } from '../../../common/interfaces/blue-ribbon-party-jackpot.interface';
import { LiveArenaWidgetCrownBox } from './boxes/crown/live-arena-widget-crown.box';
import { LiveArenaWidgetLogoBox } from './boxes/logo/live-arena-widget-logo.box';
import { LiveArenaWidgetMainContainerBox } from './boxes/main-container/live-arena-widget-main-container.box';
import { LiveArenaWidgetCapsuleContainerBox } from './boxes/capsule/live-arena-widget-capsule-container.box';
import { LiveArenaWidgetCapsuleStartBox } from './boxes/capsule/live-arena-widget-capsule-start.box';
import { LiveArenaWidgetCapsuleMidContainerBox } from './boxes/capsule/live-arena-widget-capsule-mid-container.box';
import { LiveArenaWidgetCapsuleEndBox } from './boxes/capsule/live-arena-widget-capsule-end.box';
import { LiveArenaWidgetSeparatorBox } from './boxes/capsule/separator/live-arena-widget-separator.box';
import { JackpotWidgetClockComponent } from '../jackpot-widget/jackpot-widget-clock.component';
import { LiveArenaWidgetDescriptionBox } from './boxes/capsule/description/live-arena-widget-description.box';
import { LiveArenaWidgetAmountBox } from './boxes/capsule/amount/live-arena-widget-amount.box';
import { LiveArenaWidgetClockBox } from './boxes/capsule/clock/live-arena-widget-clock.box';
import { JACKPOT_STATE, JackpotType } from '../../../common/const/jackpot_map_ids';

export interface ILiveArenaWidgetProps {
    partyJackpot: IBlueRibbonPartyJackpot;
}


@observer
export class LiveArenaWidgetComponent extends OrbitComponent<ILiveArenaWidgetProps> {

    get _isAllPartyJPAvailable() {
        return this.props.partyJackpot != null;
    }

    render() {
        if (this._isAllPartyJPAvailable && this.props.partyJackpot.isExpired) {
            return null;
        }

        return (
            <LiveArenaWidgetMainContainerBox className={CyClass('cy-live-casino-widget-container')}
                onClick={() => {
                    if (this._isAllPartyJPAvailable) {
                        this.services.partyJackpot.openJackpotInfoPage(this.props.partyJackpot.jackpotId);
                    }
                }}
            >
                <LiveArenaWidgetCrownBox/>

                <LiveArenaWidgetLogoBox/>

                {this._isAllPartyJPAvailable ? (
                    <LiveArenaWidgetCapsuleContainerBox>

                        <LiveArenaWidgetCapsuleStartBox/>

                        <LiveArenaWidgetCapsuleMidContainerBox>
                        { /* Special case for OFF HOURS (mobile): */
                        this.services.device.isMobile && this.props.partyJackpot?.getStandardJackpotState() === JACKPOT_STATE.OffHours ? <>
                            <LiveArenaWidgetDescriptionBox smallFont={true}
                                className={CyClass('cy-live-casino-widget-description')}>
                                STARTS SOON{/* Here text is hardcoded since it should fit to small place on mobile portrait */}
                            </LiveArenaWidgetDescriptionBox>
                            <LiveArenaWidgetSeparatorBox/>
                            {this._renderClock()}
                        </> : <>
                            {this._renderAmount()}
                            <LiveArenaWidgetSeparatorBox/>
                            {this._renderClock()}
                            {this._renderDescription()}
                            </>
                        }
                        </LiveArenaWidgetCapsuleMidContainerBox>

                        <LiveArenaWidgetCapsuleEndBox/>

                    </LiveArenaWidgetCapsuleContainerBox>
                ) : null}

                { this.services.mediaQuery.xs ? null : <LiveArenaWidgetCrownBox/>}

            </LiveArenaWidgetMainContainerBox>
        );
    }

    private _renderAmount() {
        if (!this._isAllPartyJPAvailable) {
            return null;
        }

        const amountInCents = this.props.partyJackpot.currentValue;
        return <LiveArenaWidgetAmountBox
            className={CyClass('cy-live-casino-widget-amount')}>
            {this.services.currency.formatMoney(amountInCents)}
        </LiveArenaWidgetAmountBox>;
    }

    private _renderClock() {
        if (!this._isAllPartyJPAvailable) {
            return null;
        }

        if (this.props.partyJackpot.mustHitTime) {
            const mustHitTimeFn = () => {
                return this.props.partyJackpot.mustHitTime;
            };

            return (
                <LiveArenaWidgetClockBox>
                    <JackpotWidgetClockComponent getMustHitTime={mustHitTimeFn}
                                                 jackpotType={JackpotType.Party}
                                                 jackpotState={this.props.partyJackpot?.getStandardJackpotState()}
                                                 forcePCView={true}
                    />
                </LiveArenaWidgetClockBox>
            );
        }

        return null;
    }

    private _getDescriptionTranslationKey(jackpotState: JACKPOT_STATE) {
        let translationKey = '';
        switch (jackpotState) {
            case JACKPOT_STATE.Hot:
                translationKey = 'JACKPOT-WIDGET-DROPS-SOON';
                break;

            case JACKPOT_STATE.OffHours:
                translationKey = 'JACKPOT-WIDGET-STARTS-SOON';
                break;

            case JACKPOT_STATE.Regular:
            default:
                translationKey = '';
                break;
        }

        return translationKey;
    }

    private _renderDescription() {
        if (!this._isAllPartyJPAvailable || this.services.device.isMobile) {
            return null;
        }

        const trKey = this._getDescriptionTranslationKey(this.props.partyJackpot?.getStandardJackpotState());
        if (!trKey) {
            return null;
        }

        return <>
            <LiveArenaWidgetSeparatorBox/>
            <LiveArenaWidgetDescriptionBox smallFont={false}
                className={CyClass('cy-live-casino-widget-description')}>
                {this.services.translation.translate(trKey)}
            </LiveArenaWidgetDescriptionBox>
        </>;
    }
}
